import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const DesktopOnly = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
